<template>
  <div class="quick-filters">
    <div class="filter-group">
      <div class="filter-label">Content Type</div>
      <div class="filter-buttons">
        <button v-for="option in contentTypeOptions" :key="option.value" :class="['filter-btn', { active: isContentTypeSelected(option.value) }]" @click="toggleContentType(option.value)">
          {{ option.label }}
        </button>
      </div>
    </div>

    <div class="filter-group">
      <div class="filter-label">Aspect Ratio</div>
      <div class="filter-buttons">
        <button v-for="option in aspectRatioOptions" :key="option.value" :class="['filter-btn', { active: isAspectRatioSelected(option.value) }]" @click="toggleAspectRatio(option.value)">
          {{ option.label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuickFilters',

  props: {
    selectedContentTypes: {
      type: Array,
      default: () => []
    },
    selectedAspectRatios: {
      type: Array,
      default: () => []
    },
    aspectRatioOptions: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      contentTypeOptions: [
        { label: 'Images', value: 'image' },
        { label: 'Videos', value: 'video' },
        { label: 'Documents', value: 'document' }
      ]
    };
  },

  methods: {
    isContentTypeSelected(value) {
      return this.selectedContentTypes.includes(value);
    },

    isAspectRatioSelected(value) {
      return this.selectedAspectRatios.includes(value);
    },

    toggleContentType(value) {
      const newSelection = [...this.selectedContentTypes];
      const index = newSelection.indexOf(value);

      if (index > -1) {
        newSelection.splice(index, 1);
      } else {
        newSelection.push(value);
      }

      this.$emit('update:content-types', newSelection);
    },

    toggleAspectRatio(value) {
      const newSelection = [...this.selectedAspectRatios];
      const index = newSelection.indexOf(value);

      if (index > -1) {
        newSelection.splice(index, 1);
      } else {
        newSelection.push(value);
      }

      this.$emit('update:aspect-ratios', newSelection);
    }
  }
};
</script>

<style lang="scss" scoped>
.quick-filters {
  display: flex;
  gap: 24px;
  align-items: center;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-label {
  @include inter-font($size: 14px, $color: var(--secondary-text-color), $weight: 500);
  white-space: nowrap;
}

.filter-buttons {
  display: flex;
  gap: 6px;
}

.filter-btn {
  @include inter-font($size: 13px, $color: var(--secondary-text-color), $weight: 500);
  padding: 6px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: #f9fafb;
    border-color: #d1d5db;
  }

  &.active {
    background: var(--light-main-color);
    border-color: var(--main-btn-color);
    color: var(--main-text-color);
    font-weight: 600;
  }
}

@media (max-width: 640px) {
  .quick-filters {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  .filter-group {
    width: 100%;
  }

  .filter-buttons {
    flex: 1;
    justify-content: space-between;
  }

  .filter-btn {
    flex: 1;
    text-align: center;
  }
}
</style>
